import styled from 'styled-components'

import MainLayout from '../../layouts/MainLayout'
import ProductsGrid from '../../components/ProductsGrid'
import CategoryBanner from '../../components/BannerListing'
import SortingFilters from '../../components/SortingFilters'
import ActionButton from '../../components/ActionButton'
import SectionWrapper from '../../components/SectionWrapper'
import TextBanner from '../../components/TextBanner'

export const Layout = styled(MainLayout)`
  main {
    margin-top: 0;
  }
`

export const FiltersBanner = styled(SortingFilters)``

export const ProductList = styled(ProductsGrid)``
export const Banner = styled(CategoryBanner)``

export const SeeMoreButton = styled(ActionButton)``

export const Centered = styled(SectionWrapper)`
  text-align: center;
`

export const InfoBanner = styled(TextBanner)`
  background-color: ${({ theme }) => theme.colors.brownBack};
  & .BoxedContainer > * {
    ${({ theme }) => theme.textStyles.montserratTextBaseMedium};
  }
`
